import styled from "styled-components";
import {IonMenu} from "@ionic/react";
import React from "react";
import {observer} from "mobx-react";
import {AgencySideMenuHeaderComponent} from "./agency-side-menu-header.component";
import {AgencySideMenuContent} from "./agency-side-menu-content.component";
import {AgencySideMenuFooter} from "./agency-side-menu-footer.component";
import {useServices} from "../../../hooks/use-services.hook";

const IonMenuBox = styled(IonMenu)`

    ${props => props.theme.screenMediaQuery.xsAndBelow} {
        width: 100vw;
        &::part(container) {
            width: 100vw;
        }    
    }
`

export const AgencySideMenuComponent: React.FC = observer(() => {
    const services = useServices();
    const sideMenuController = services.sideMenu.agencyMainSideMenuController;
    return (
        <IonMenuBox menuId={sideMenuController.menuId}
                    contentId={sideMenuController.contentId}
                    side={"end"}>
            <AgencySideMenuHeaderComponent/>
            <AgencySideMenuContent/>
            <AgencySideMenuFooter/>
        </IonMenuBox>
);
})